import { Directive, Input, ViewContainerRef, TemplateRef, OnInit, ElementRef } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { Router } from "@angular/router";

@Directive({
  selector: '[acl]'
})
export class AclDirective implements OnInit {

  @Input('acl') acl: string;

  roleSections = [];
  user: any;
  accessName = "";
  accessPerm = "";
  accessLoad = false;
  constructor(
    private userService: UserService,
    public router: Router,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private el: ElementRef
  ) {
    // this.viewContainer.createEmbeddedView(this.templateRef);
    this.user = this.userService.getLoggedInUser();
    if(!this.user.role){
      //using few components in public view also where 
      //we have used acl directive
      //we want it should show commponent properly
      this.user.role = {
        modules: []
      }
      this.user.isPackagePurchased = 0;
    }
    this.user.role.modules.forEach((v, i) => {
      this.roleSections.push(v.name)
    })
  }

  isUserSubscribed() {
    if (this.user.isPackagePurchased == 1) {
      return true;
    } else {
      return false;
    }
  }

  checkAccess() {
    let tempAcl = this.acl.split(":");
    this.accessName = tempAcl[0];
    this.accessPerm = (typeof tempAcl[1] == "undefined" ? "read" : tempAcl[1]);
    if (tempAcl[2] == "undefined" || tempAcl[2] == "") {
      this.accessLoad = false;
    }
    if (tempAcl[2] == "true") {
      this.accessLoad = true
    }
    //if user has access for all sections then set accessName to 'all'
    if(this.roleSections.includes("all")){
      this.accessName = "all";
    }
    if (this.roleSections.includes(this.accessName) || this.roleSections.includes("all")) {
      let hasAccess = false;
      //check permission for sections
      this.user.role.modules.forEach((v,i)=>{
        if(v.name == this.accessName){
          let p = ["read"];
          if(v.grantPermission == "write"){
            p.push(v.grantPermission);
          }
          //if user has write permission OR user has read permission and want to access a section with write permission
          if(p.includes(this.accessPerm) || (this.accessPerm == "no-write" && v.grantPermission != "write")){
            hasAccess = true;
          }
        }
      })
      return hasAccess; 
    } else {
      return false;
    }
  }

  ngOnInit() {  
    let hasSubscription = this.isUserSubscribed()
    let hasAccess = this.checkAccess();
    if (!hasSubscription || !hasAccess) {
      if (this.accessLoad) {
        //send to dashboard
        this.router.navigate(["/dashboard"]);
      } else {
        //hide section
        this.viewContainer.clear()
      }
    } else {
      //show section
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/directives/acl/acl.directive.ts